import {createSelector} from '@reduxjs/toolkit'
import {RootState} from 'app/rootReducer'
import {SSLInspectionStatus} from 'interfaces'
import {hasCloudAppUnsavedChanges} from './CloudApp/cloudApp.utils'
import {isCloudAppLocked, PoliciesState} from './policiesSlice'

function getPolicies(state: RootState): PoliciesState {
  return state.policies
}

export const selectPolicies = createSelector(getPolicies, policies => policies)

export const selectCloudApp = (state: RootState): PoliciesState['cloudApp'] =>
  state.policies.cloudApp

/** True while any Cloud App save is in flight; only one runs at a time. */
export const selectIsCloudAppSaving = (state: RootState): boolean =>
  state.policies.cloudApp.savingPolicyName !== undefined

export const selectIsCloudAppLocked = (state: RootState): boolean =>
  isCloudAppLocked(state.policies)

export const selectCloudAppHasUnsavedChanges = createSelector(
  (state: RootState) => state.policies.cloudApp.data,
  (state: RootState) => state.policies.cloudApp.snapshot,
  hasCloudAppUnsavedChanges,
)

// Return this SSL Inspection state from unsaved (in-progress) data
export const selectSSLInspectionDisabledInData = createSelector(
  getPolicies,
  ({sslInspectionState}) =>
    sslInspectionState.data === SSLInspectionStatus.DISABLED ||
    (sslInspectionState.data === SSLInspectionStatus.BASE &&
      sslInspectionState.basePolicy === SSLInspectionStatus.DISABLED),
)

// Return this SSL Inspection state from current working data
export const selectSSlInspectionEnabled = createSelector(
  getPolicies,
  ({sslInspectionState}) =>
    sslInspectionState.data === SSLInspectionStatus.ENABLED ||
    (sslInspectionState.data === SSLInspectionStatus.BASE &&
      sslInspectionState.basePolicy === SSLInspectionStatus.ENABLED),
)

export const selectSSLInspectionInherited = createSelector(
  getPolicies,
  ({sslInspectionState}) =>
    sslInspectionState.data === SSLInspectionStatus.BASE,
)

export const selectSSLInspectionData = createSelector(
  getPolicies,
  ({sslInspectionState}) => sslInspectionState.data,
)

export const selectSSLInspectionSnapshot = createSelector(
  getPolicies,
  ({sslInspectionState}) => sslInspectionState.snapshot,
)
